import React from 'react'
import Navbar from '../components/Navbar'
import IntroPage from '../components/IntroPage'
import Footer from '../components/Footer'
import AboutContent from '../components/AboutContent'
import Project from './Project'
import ProgressPage from '../components/Progresspage'

const Home = () => {
  return (
    <div>
      {/* <Navbar />
      <IntroPage /> */}
      {/* <Project /> */}
      {/* <AboutContent />
      <Footer /> */}
      <ProgressPage />
    </div>
  )
}

export default Home